import { useEffect, useState } from "react";

const useOptimizelyDecision = (attribute) => {
  const attributeName = attribute || "data-is-opt-variant";
  const [variantValue, setVariantValue] = useState(null);

  useEffect(() => {
    const onBodyAttributeMutation = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === attributeName
        ) {
          const bodyElement = document.body;
          const optBodyAttribute = bodyElement.getAttribute(attributeName);

          setVariantValue(optBodyAttribute);
        }
      }
    };

    const bodyElement = document.body;
    const optBodyAttribute = bodyElement.getAttribute(attributeName);
    setVariantValue(optBodyAttribute);

    const observer = new MutationObserver(onBodyAttributeMutation);

    observer.observe(bodyElement, {
      attributeFilter: [attributeName],
      attributes: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [attributeName]);

  return variantValue;
};

export default useOptimizelyDecision;
